module.exports = {
  "wxc-tag": {
    "borderColor": "#3d3d3d",
    "borderWidth": 2,
    "borderRadius": 4,
    "marginRight": 6,
    "backgroundColor": "rgba(0,0,0,0)",
    "paddingLeft": 6,
    "paddingRight": 6,
    "height": 26,
    "justifyContent": "center",
    "alignItems": "center"
  },
  "tag-text": {
    "fontSize": 20,
    "color": "#3d3d3d"
  },
  "black": {
    "color": "#3D3D3D"
  },
  "yellow": {
    "color": "#EE9900"
  },
  "blue": {
    "color": "#30A0FF"
  },
  "gray": {
    "color": "#A5A5A5"
  },
  "red": {
    "color": "#FF5000"
  },
  "border-black": {
    "borderColor": "#A5A5A5"
  },
  "border-yellow": {
    "borderColor": "#EE9900"
  },
  "border-gray": {
    "borderColor": "#A5A5A5"
  },
  "border-red": {
    "borderColor": "#FF5000"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-b3e21d60!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-rich-text/wxc-rich-text-tag.vue
// module id = 157
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28